import MathHelper from "@/helpers/math";

export default class {
    _id;
    _measurement;
    _ndsRate;
    _ndsValue;
    _price;
    _product;
    _productCode;
    _quantity;
    _quantityLeft;
    _total;
    _catalogCode;
    _totalWithNds;
    _customerCode;
    _customerSystemId;
    _customerShipmentItemId;

    constructor() {
        this._id = null
        this._product = ''
        this._productCode = null
        this._measurement = null
        this._ndsRate = null
        this._ndsValue = 0
        this._price = 0
        this._quantity = 0
        this._total = 0
        this._totalWithNds = 0
        this._customerCode = null;
        this._customerSystemId = null
        this._quantityLeft = 0
        this._catalogCode = null
    }

    get id() {
        return this._id
    }

    set id(value) {
        this._id = value
    }

    get measurement() {
        return this._measurement
    }

    set measurement(value) {
        this._measurement = value
    }

    get ndsRate() {
        return this._ndsRate
    }

    set ndsRate(value) {
        this._ndsRate = value

        this.recalculateComputes()
    }

    get ndsValue() {
        return this._ndsValue
    }

    get price() {
        return this._price
    }

    set price(value) {
        this._price = value

        this.recalculateComputes()
    }

    get product() {
        return this._product
    }

    set product(value) {
        this._product = value
    }

    get productCode() {
        return this._productCode
    }

    set productCode(value) {
        this._productCode = value
    }

    get quantity() {
        return this._quantity
    }

    set quantity(value) {
        this._quantity = value

        this.recalculateComputes()
    }

    get quantityLeft() {
        return this._quantityLeft
    }

    set quantityLeft(value) {
        this._quantityLeft = value
    }

    get total() {
        return this._total
    }

    get totalWithNds() {
        return this._totalWithNds
    }

    get customerCode() {
        return this._customerCode
    }

    set customerCode(value) {
        this._customerCode = value
    }

    get customerSystemId() {
        return this._customerSystemId
    }

    set customerSystemId(value) {
        this._customerSystemId = value
    }

    get customerShipmentItemId() {
        return this._customerShipmentItemId
    }

    set customerShipmentItemId(value) {
        this._customerShipmentItemId = value
    }

    get catalogCode() {
        return this._catalogCode
    }

    set catalogCode(value) {
        this._catalogCode = value
    }

    recalculateComputes() {
        const ndsMultiplier = MathHelper.multiply(this._ndsRate, 0.01);

        this._total = MathHelper.multiply(this._price, this._quantity);
        this._ndsValue = MathHelper.multiply(this._total, ndsMultiplier);
        this._totalWithNds = this._total + this.ndsValue;
    }
}